/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAIConfigCompletionPathParams = NonNullable<operations['postAIConfigCompletion']['parameters']['path']>;

export type PostAIConfigCompletionRequestBody = OperationRequestBodyContent<operations['postAIConfigCompletion']>;

export interface Input extends PostAIConfigCompletionPathParams {
  apiVersion?: string;
  body: PostAIConfigCompletionRequestBody;
  header: NonNullable<operations['postAIConfigCompletion']['parameters']['header']>;
}

export async function postAIConfigCompletion(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/ai-configs/{configKey}/completion', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
